import Api from "js/api/authorisedApi";

export interface MaxEndTimeResponse {
	max_end_time_utc_str: string;
	current_utc_str: string;
}

export interface LocalisedMaxEndTime {
	localEndTime: Date;
	localStartTime: Date;
}

export function fetchMaxEndTime(): Promise<MaxEndTimeResponse | null> {
	return new Promise((resolve, reject) => {
		Api.get(
			"/backend/classroom/max-end-time",
			(data: MaxEndTimeResponse) => {
				if (!data.max_end_time_utc_str) {
					resolve(null);
				} else {
					resolve(data);
				}
			},
			reject
		);
	});
}

export function localiseMaxEndTime(maxEndTime: MaxEndTimeResponse): LocalisedMaxEndTime {
	return {
		localEndTime: new Date(maxEndTime.max_end_time_utc_str),
		localStartTime: new Date(maxEndTime.current_utc_str),
	};
}
